import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Badge — etiqueta pequeña para estados, roles, contadores.
 *
 * @example
 * <Badge>248</Badge>
 * <Badge variant="success">Activo</Badge>
 * <Badge variant="warning">Pendiente</Badge>
 * <Badge variant="destructive">Baja</Badge>
 * <Badge variant="outline">Externo</Badge>
 */

const variantClasses = {
  default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
  secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  outline: "text-foreground border-border",
  accent: "border-transparent bg-accent text-accent-foreground",
  success: "border-transparent bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  warning: "border-transparent bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  destructive: "border-transparent bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300",
};

export const Badge = ({ className, variant = "default", ...props }) => {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium transition-colors",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        variantClasses[variant],
        className
      )}
      {...props}
    />
  );
};
